import type { SocialProfileNetworkType } from '@/types/socialProfileType';

import {
    FACEBOOK,
    INSTAGRAM,
    LINKEDIN,
    PINTEREST,
    THREADS,
    TIKTOK_BUSINESS,
    TWITTER,
    X
} from '@/lib/socialProfile';

export const availableSP: SocialProfileNetworkType[] = [
    INSTAGRAM,
    FACEBOOK,
    TWITTER,
    X,
    LINKEDIN,
    TIKTOK_BUSINESS,
    PINTEREST,
    THREADS
];
